/*
|‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾|
|                              - OVERLAY HEADER DRAWER BRIDGE -                              |
|____________________________________________________________________________________________|
*/

(() => {
  const SELECTOR_TRIGGER = '[data-header-drawer-trigger], [data-overlay-open="header-drawer"]';
  const SELECTOR_OVERLAY = '.overlay-header-drawer';
  const DETAILS_ID = 'Details-menu-drawer-container';

  const getDetails = () => {
    const overlay = document.querySelector(SELECTOR_OVERLAY);
    if (!overlay) return null;

    return (
      overlay.querySelector(`#${CSS.escape(DETAILS_ID)}`) ||
      overlay.querySelector('header-drawer details.menu-drawer-container') ||
      overlay.querySelector('details.menu-drawer-container')
    );
  };

  const getDrawerEl = (details) => details?.closest('header-drawer') || null;

  const setTriggerExpanded = (expanded) => {
    document.querySelectorAll(SELECTOR_TRIGGER).forEach((btn) => {
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  };

  const openDrawer = () => {
    const details = getDetails();
    if (!details) return;

    if (!details.hasAttribute('open')) details.setAttribute('open', '');

    const drawer = getDrawerEl(details);
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
    } else {
      details.classList.add('menu-open');
    }

    setTriggerExpanded(true);
  };

  const closeDrawer = () => {
    const details = getDetails();
    if (!details) return;

    const drawer = getDrawerEl(details);
    if (drawer && typeof drawer.close === 'function') {
      drawer.close();
    } else {
      details.classList.remove('menu-open');
      details.removeAttribute('open');
      details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    }

    setTriggerExpanded(false);
  };

  const toggleDrawer = () => {
    const details = getDetails();
    if (!details) return;

    if (details.hasAttribute('open')) closeDrawer();
    else openDrawer();
  };

  const bindDetailsToggleListener = () => {
    const details = getDetails();
    if (!details || details.__overlayBound) return;

    details.__overlayBound = true;

    // native details toggle event (fires on open/close)
    details.addEventListener('toggle', () => {
      setTriggerExpanded(details.hasAttribute('open'));
    });
  };

  // Click delegation (überlebt Theme-Editor Re-Render!)
  document.addEventListener('click', (e) => {
    const btn = e.target.closest(SELECTOR_TRIGGER);
    if (!btn) return;

    e.preventDefault();
    bindDetailsToggleListener();
    toggleDrawer();
  });

  const rebind = () => {
    bindDetailsToggleListener();
    const details = getDetails();
    if (details) setTriggerExpanded(details.hasAttribute('open'));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rebind);
  } else {
    rebind();
  }

  // Shopify Theme Editor events (wenn Section neu gerendert wird)
  document.addEventListener('shopify:section:load', rebind);
  document.addEventListener('shopify:section:select', rebind);
  document.addEventListener('shopify:section:deselect', rebind);
})();
